import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// material-ui
import ButtonBase from '@mui/material/ButtonBase';
import CardContent from '@mui/material/CardContent';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project imports
import ProfileTab from './ProfileTab';
import Avatar from 'components/@extended/Avatar';
import MainCard from 'components/MainCard';
import Transitions from 'components/@extended/Transitions';
import IconButton from 'components/@extended/IconButton';
import useAuth from 'hooks/useAuth';
import { ROL_ETIKETLERI } from 'utils/roles';

// assets
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';

function initialleriAl(adSoyad) {
  if (!adSoyad) return '?';
  const parcalar = adSoyad.trim().split(/\s+/);
  const ilk = parcalar[0]?.[0] ?? '';
  const son = parcalar.length > 1 ? parcalar[parcalar.length - 1][0] : '';
  return (ilk + son).toUpperCase();
}

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

export default function Profile() {
  const { logout, adSoyad, kullaniciTipi } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const gorunenAd = adSoyad || 'Kullanıcı';
  const rolEtiketi = ROL_ETIKETLERI[kullaniciTipi] ?? '';

  return (
    <Box sx={{ flexShrink: 0, ml: 'auto' }}>
      <Tooltip title="Profil" disableInteractive>
        <ButtonBase
          sx={(theme) => ({
            p: 0.25,
            borderRadius: 1,
            '&:focus-visible': { outline: `2px solid ${theme.vars.palette.secondary.dark}`, outlineOffset: 2 }
          })}
          aria-label="profili aç"
          ref={anchorRef}
          aria-controls={open ? 'profile-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <Avatar alt={gorunenAd} color="primary" type="filled" size="sm" sx={{ '&:hover': { outline: '1px solid', outlineColor: 'primary.main' } }}>
            {initialleriAl(adSoyad)}
          </Avatar>
        </ButtonBase>
      </Tooltip>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 9]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions type="grow" position="top-right" in={open} {...TransitionProps}>
            <Paper sx={(theme) => ({ boxShadow: theme.vars.customShadows.z1, width: 290, minWidth: 240, maxWidth: { xs: 250, md: 290 } })}>
              <ClickAwayListener onClickAway={handleClose}>
                <MainCard elevation={0} border={false} content={false}>
                  <CardContent sx={{ px: 2.5, pt: 3 }}>
                    <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                      <Stack direction="row" sx={{ gap: 1.25, alignItems: 'center' }}>
                        <Avatar alt={gorunenAd} color="primary" type="filled" sx={{ width: 32, height: 32 }}>
                          {initialleriAl(adSoyad)}
                        </Avatar>
                        <Stack>
                          <Typography variant="h6">{gorunenAd}</Typography>
                          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                            {rolEtiketi}
                          </Typography>
                        </Stack>
                      </Stack>
                      <Tooltip title="Çıkış Yap">
                        <IconButton size="large" sx={{ color: 'text.primary' }} onClick={handleLogout}>
                          <LogoutOutlined />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </CardContent>

                  <Box sx={{ borderTop: 1, borderColor: 'divider', py: 1 }}>
                    <ProfileTab />
                  </Box>
                </MainCard>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </Box>
  );
}
